var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Este reporte muestra el número de secciones abiertas por cada curso en el periodo y carrera seleccionados.")])])}]

export { render, staticRenderFns }